import * as React from 'react';
import { useNavigate } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Service from '../../../util/Service';
import { Container, Paper, PopoverPaper, Snackbar, Tooltip } from '@mui/material';
import HtmlContent from '../../util/HtmlContent';
import { Edit, ExitToApp, Save } from '@mui/icons-material';
import VeryEditor2 from '../../common/EditorVery/VeryEditor2';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function EventoDialog(props) {
    const { open, setOpen, idEvento } = props;
    const navigate = useNavigate();
    const [evento, setEvento] = React.useState();
    const [openSnack, setOpenSnack] = React.useState(false);
    const [wait, setWait] = React.useState(true);
    const [edit, setEdit] = React.useState(false);

    const ref = React.useRef();

    React.useEffect(() => {
        if (open && idEvento) {
            buscaEvento();
        }
    }, [idEvento, open])

    function buscaEvento() {
        setWait(true);
        Service.GET("/api/security/evento/" + idEvento).then(r => {
            console.log("Retorno do Backend:", r);

            if (r && r.pagina && typeof r.pagina === 'string') {
                if (r.pagina.startsWith('/')) {
                    navigate(r.pagina);
                    return;
                }
            }

            if (!r) {
                setEvento({ nomeCurto: "Evento não encontrado", pagina: "" });
            } else {
                setEvento(r);
            }

            setWait(false);
        }).catch(erro => {
            console.error("Erro ao buscar detalhes do evento:", erro);
            setEvento({ nomeCurto: "Erro na requisição", pagina: "" });
            setWait(false);
        });
    }
    function handleEdit() {
        console.log('>>handleEdit<<');
        setEdit(true);
    }
    function handleSalva() {
        console.log('>>handleSalva<<')

        const html = ref.current.getHtml();
        const dado = { ...evento };
        dado.pagina = html;


        Service.POST("/api/security/eventoHtml", dado).then(r => {
            console.log(r);
            if (r.success) {
                setOpenSnack(true);
                setEvento(r.dado);
            } else {
                alert(r.msg);
            }
        });
    }
    const handleClose = () => {
        setOpen(false);
    };
    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }

    function getTitulo() {
        if (wait) return 'aguarde...'
        let txt = '';
        if (evento) {
            txt = evento.nome;
            txt += " " + formataData(evento.dtInicial);
            if (evento.dtFinal) {
                txt += " até " + formataData(evento.dtFinal);
            }
        }

        return txt;
    }

    function editMode() {

        if (edit === true) {
            return (
                <Container sx={{ mt: 2, }}>
                    <div className='edit'>
                        <Tooltip title="Sair da edição">
                            <IconButton aria-label="edit" color="primary"
                                onClick={() => setEdit(false)}
                            >
                                <ExitToApp />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Salvar pagina">
                            <IconButton aria-label="edit" color="primary"
                                onClick={handleSalva}
                            >
                                <Save />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <VeryEditor2
                        html={evento.pagina}
                        ref={ref}
                        style={{
                            padding: 4, border: '2px solid black', overflow: 'auto', maxHeight: '80vh',
                            height: "60vh"
                        }}
                    />
                </Container>
            )
        }
        return;
    }
    return (

        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            slots={{
                transition: Transition,
            }}
        >
            {editMode()}
            {!edit &&
                <React.Fragment>
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                {getTitulo()}
                            </Typography>

                            <IconButton aria-label="edit" color="inherit" onClick={handleEdit}>
                                <Edit />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Typography variant='h4' align='center'>
                        {evento && evento.nomeCurto}
                    </Typography>
                    <Paper sx={{ p: 1, m: 1 }}>
                        {evento && <HtmlContent htmlString={evento.pagina} edit={false} />}
                    </Paper>
                </React.Fragment>
            }
            <Snackbar
                open={openSnack}
                autoHideDuration={5000}
                onClose={() => setOpenSnack(false)}
                message="Salvo com sucesso"
            />

        </Dialog>
    );
}
